import CommonMapper from '@/modules/core/mappers/CommonMapper'
import SaveQuotationRequest from '@/modules/common/common/models/MID/requests/SaveQuotationRequest'
import type Insurance from '@/modules/common/common/models/APP/Insurance'
import type { UserRoleEnum } from '@/modules/core/models/enums'

export default class SaveQuotationMapper {
  static toRequest(
    quotationId: string,
    startDate: Date,
    billingCycle: string,
    product: Insurance,
    role: UserRoleEnum | undefined = undefined,
    endDate?: Date | null
  ): SaveQuotationRequest {
    const hiringObject: any = {
      ...product,
      billingCycle: CommonMapper.toDXPProductPrice(billingCycle),
      insuranceStartDate: CommonMapper.toMiddlewareDate(startDate),
      role,
      quotationNumber:
        product.quotationNumber !== undefined ? Number(product.quotationNumber) : undefined
    }
    if (endDate) {
      hiringObject.insuranceEndDate = CommonMapper.toMiddlewareDate(endDate)
    }
    return new SaveQuotationRequest({
      quotationId,
      hiring: hiringObject
    })
  }
}
